// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ragtestEntity from './entities/ragtest.json';
import ragtestMenu from '../pages/ragtest/menu.json';
import ragtestFullForm from '../pages/ragtest/forms/full.json';
import ragtestContextForm from '../pages/ragtest/forms/context.json';
import ragtestMiniForm from '../pages/ragtest/forms/mini.json';
import ragtestLookupForm from '../pages/ragtest/forms/lookup.json';
import ragtestTableView from '../pages/ragtest/views/table.json';
import ragtestStagesView from '../pages/ragtest/views/stages.json';
import ragtestCardsView from '../pages/ragtest/views/cards.json';
import ragtestInlineView from '../pages/ragtest/views/inline.json';
import ragtestBacklogView from '../pages/ragtest/views/backlog.json';
import ragtestSplitView from '../pages/ragtest/views/split.json';
import ragtestCalendarView from '../pages/ragtest/views/calendar.json';
import ragtestDashboardView from '../pages/ragtest/views/dashboard.json';

/** Тип запису «Контрольне питання» зі сторінками пакета: меню, форми та подання з pages/ragtest/. */
export const ragtestDefinition: IRecordTypeDefinition = {
  ...ragtestEntity,
  views: assembleViewSet({
      table: ragtestTableView,
      stages: ragtestStagesView,
      cards: ragtestCardsView,
      inline: ragtestInlineView,
      backlog: ragtestBacklogView,
      split: ragtestSplitView,
      calendar: ragtestCalendarView,
      dashboard: ragtestDashboardView,
  }),
  form: ragtestFullForm,
  forms: { full: ragtestFullForm, context: ragtestContextForm, mini: ragtestMiniForm, lookup: ragtestLookupForm },
  menu: ragtestMenu,
} as IRecordTypeDefinition;
